import { ConsultModel, ConsultQueryName, ConsultEntity } from '@tencent/dz-models';
import { verifyAuditClient } from 'src/utils';

export class ImpConsultModel extends ConsultModel {
  // 全屏，半屏
  public from: string;
  // 搜索词
  public queryWord: string;
  // 关键词
  public keyWord: string;
  // 审核场景
  public isAudit: boolean;
  // 预览场景
  public isPreview: boolean;
  // 系统限制
  public isLimited: boolean;
  // 是否是巡检
  public isInspection: boolean;
  // 被标记为骚扰的客户
  public isCursed = false;
  // 审核快照场景
  public isAuditSnap = false;

  public hitTheGray = false;
  // ai 机器人token
  public snapshotToken = '';
  // 疾病
  public disease: string;

  constructor(consult: ConsultEntity, citoken: string) {
    super(consult, citoken);
    const consultConfig = this.getConsultConfig();
    this.from = this.getQueryParams(ConsultQueryName.From);
    this.queryWord = this.getQueryParams(ConsultQueryName.Query_Word);
    this.keyWord = this.getQueryParams(ConsultQueryName.Key_Word);
    this.isAudit = this.getQueryParams(ConsultQueryName.Page_Status) === '1';
    this.isPreview = this.getQueryParams(ConsultQueryName.Page_Status) === '2';
    this.snapshotToken = this.getQueryParams(ConsultQueryName.Snapshot_Token);
    this.isLimited = consult.is_limit || false;
    // window.isInspection初始化在index.html
    this.isInspection = window.isInspection;
    this.isCursed = !!consultConfig.is_guest_id_cursed;
    this.isAuditSnap = this.isAuditSnapTraffic();
    this.hitTheGray = (consult as any).use_new_interface_flag;
    this.disease = this.getQueryParams(ConsultQueryName.Disease);
  }

  public setIsLimited(val: boolean) {
    this.isLimited = val;
    this.onUpdate();
  }


  public unConnectIm() {
    return this.isCursed
      || this.isAudit
      || this.isPreview
      || this.isInspection
      || this.isAuditSnap
      || this.isAIStaffPreviewTraffic();
  }

  public setIsCursed(value: boolean) {
    this.isCursed = value;
  }

  // ai 机器人预览流量
  public isAIStaffPreviewTraffic() {
    return !!this.snapshotToken;
  }

  // ai 机器人真实访问
  public isAIStaffTraffic() {
    const { platform_type } = this.getConsultConfig() as any;
    return platform_type === 21;
  }

  public isAuditSnapTraffic() {
    // 设备参数匹配 并且 clickid不存在才属于审核快照流量
    return verifyAuditClient() && !this.clickID;
  }

  public async getCitoken() {

  }
}
